module.exports = __webpack_public_path__ + "img/3.fdbf4d81.png";